export { default } from "./CurtailmentObjectTab";
